import { useMemo } from 'react';
import styled from '@emotion/styled';
import { FlightSearchRow } from './FlightSearchRow';
import { Css, Flex, UnstyledUl } from '../../../../ui';
import { getFlightDayAndDate } from '../../../flights/detail/ui/helpers/getFlightDayAndDate';
import { generateFlightsDayGroups } from '../../../../utils/generateFlightsDayGroups';
import { IEnrichedFlight } from '../../../flights/shared/flight/domain/models/IEnrichedFlight';
import { Color } from '../../../../styles/Color';

interface IFlightSearchDayGroupsProps {
	flights: IEnrichedFlight[];
	topRightSlot: JSX.Element;
}

export default function FlightSearchDayGroups({
	flights,
	topRightSlot,
}: IFlightSearchDayGroupsProps) {
	const dayGroups = useMemo(() => generateFlightsDayGroups(flights), [flights]);

	return (
		<Flex direction="column" gap="16">
			{dayGroups.map((group, index) => (
				<div key={group.id}>
					<DayGroupHeading>
						<FlightDayAndDate>
							{getFlightDayAndDate(group.dateTime)}
						</FlightDayAndDate>
						{index === 0 && topRightSlot}
					</DayGroupHeading>
					<StyledTable>
						{group.flights.map((flight) => (
							<FlightSearchRow key={flight.id} flight={flight} />
						))}
					</StyledTable>
				</div>
			))}
		</Flex>
	);
}

const DayGroupHeading = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: ${Css.pxToRem(12)};
`;

const FlightDayAndDate = styled.div`
	font-size: ${Css.pxToRem(14)};
	font-weight: 700;
	color: ${Color.SecondaryDarkBlue};
`;

export const StyledTable = styled(UnstyledUl)`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(8)};
`;
